/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/warenkorb-action-info.ts.
 */
import {GuiMessage} from './gui-message';

/**
 * Zweck: Beschreibt class WarenkorbActionInfo und ihren Daten- oder Funktionsvertrag.
 */
export class WarenkorbActionInfo {
  action: string;
  info: GuiMessage;
}
